import type { FC } from 'react';
import { Settings } from '@/components/settings/index.tsx';

export const SettingsPage: FC = () => <Settings />;
